import { Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { If } from "lib/@components/switch"
import { Repeat } from "lib/@components/repeat"
import { isEnabled } from "lib/@components/feature"
import { getReference, setReference } from "lib/@hooks/use-reference"
import { NavSwitcher } from "lib/@components/nav-switcher/nav-switcher"
import { ApplicationDisplay } from "./application-display"
import { ApplicationIcon } from "./application-icon"
import { ApplicationMenuItem } from "./application-menu-item"
import { useApplicationSwitcherSync } from "lib/@components/application-switcher/useApplicationSwitcherSync"
import { FEATURE_FLAG_APPLICATION_SWITCHER } from "lib/@components/application-switcher/application-switcher"

export function ApplicationSwitcher({ isCollapse }) {
    const { showHelp } = getReference({ showHelp: false })

    const { options, selected, selectApp } = useApplicationSwitcherSync()
    if (!options.length) return null
    if (!isEnabled(FEATURE_FLAG_APPLICATION_SWITCHER)) {
        return <ApplicationDisplay application={selected} isCollapse={isCollapse} />
    }

    const applicationName = selected?.name ?? "Applications"
    const availableOptions = options.filter(isNotSelected)
    const canSwitch = availableOptions.length > 0

    return (
        <NavSwitcher
            id="application-switcher-menu"
            dataCy="application-switcher-trigger"
            tooltip={getTooltip()}
            hiddenLabel={isCollapse ? `Current application: ${applicationName}` : "Current application:"}
            menuLabel="Applications"
            canSwitch={canSwitch}
            isCollapse={isCollapse}
            face={
                <>
                    <ApplicationIcon appId={selected?.id} icon={selected?.icon} width={40} height={40} />
                    <If value={!isCollapse}>
                        <Typography component="span" variant="subtitle1" noWrap>
                            {selected?.name}
                        </Typography>
                    </If>
                </>
            }
        >
            <Bound selectApplication={selectApplication}>
                <Repeat list={availableOptions} item={<ApplicationMenuItem />} keyFn={byId} />
            </Bound>
        </NavSwitcher>
    )

    function getTooltip() {
        if (!isCollapse) return undefined
        return canSwitch ? "Switch application" : applicationName
    }

    function selectApplication(id) {
        selectApp(id)
        if (showHelp) setReference({ showHelp: false }, "help")
    }

    function isNotSelected(option) {
        return option.id !== selected?.id
    }

    function byId(option) {
        return option.id
    }
}
